var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrapper" }, [
    _c(
      "div",
      { staticClass: "previous arrow-btn", on: { click: _vm.previous } },
      [
        _c("i", {
          staticClass: "fas fa-chevron-left",
          attrs: { "aria-hidden": "true" },
        }),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "slider-container",
        attrs: { id: "testimonial-container" },
      },
      [
        _c(
          "div",
          {
            staticClass: "slider",
            style: {
              width: _vm.sliderWidth + "px",
              left: _vm.leftPosition + "px",
            },
            attrs: { id: "testimonial-slider" },
          },
          _vm._l(_vm.testimonials, function (testimonial, index) {
            return _c(
              "div",
              {
                directives: [
                  {
                    name: "touch",
                    rawName: "v-touch:swipe.left",
                    value: _vm.next,
                    expression: "next",
                    arg: "swipe",
                    modifiers: { left: true },
                  },
                  {
                    name: "touch",
                    rawName: "v-touch:swipe.right",
                    value: _vm.previous,
                    expression: "previous",
                    arg: "swipe",
                    modifiers: { right: true },
                  },
                ],
                key: index,
                staticClass: "slide",
                style: { width: _vm.slideWidth + "px" },
                attrs: { id: "testimonial-slide-" + index },
              },
              [
                _c("div", { staticClass: "quote p-3 p-xl-5" }, [
                  _c("blockquote", [
                    _c("span", { staticClass: "blockquote-img" }),
                    _vm._v(" "),
                    _c("p", {
                      domProps: { innerHTML: _vm._s(testimonial.post_content) },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "blockquote-img flipped" }),
                    _vm._v(" "),
                    _c("footer", [
                      _vm._v("— " + _vm._s(testimonial.settings.author)),
                    ]),
                  ]),
                ]),
              ]
            )
          }),
          0
        ),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "next arrow-btn", on: { click: _vm.next } }, [
      _c("i", {
        staticClass: "fas fa-chevron-right",
        attrs: { "aria-hidden": "true" },
      }),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "indicators text-center mt-4" },
      _vm._l(_vm.testimonials, function (_, index) {
        return _c("span", {
          staticClass: "d-inline-block mr-4 indicator",
          class: {
            active: _vm.currentSlide === index,
          },
          attrs: { "aria-hidden": "true" },
          on: {
            click: function ($event) {
              return _vm.setSlide(index)
            },
          },
        })
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }